import { useIndicators, useRanking } from '@/hooks';
import { IVariacoes } from '@/mock/indicators';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Container, ContainerCard, LayerDiv } from './styles';

interface CardDataProps {
  ranking: any;
  config: any;
  destaques: any;
}
export interface CardProps {
  background: string;
  img?: string;
  data?: IVariacoes;
  i?: any
}
export const Card: React.FC<CardProps> = ({ background, data, i }) => {

  return (
    <ContainerCard background={background}>
        { data?.indicators_icon !== undefined && (
          data?.indicators_icon[i]
        ) }
        <div dangerouslySetInnerHTML={{ __html: `<p>${data?.complete_name as unknown as string}</p>` }} >
                </div>
    </ContainerCard>
  )
}

export const IndicatorSynthesis: React.FC = () => {
  const router = useRouter();
  const { RakingData, researchArea } = useRanking();
  const [data, setData] = useState<CardDataProps>();
  const { indicatorsData, handleCommitedIndicator } = useIndicators()

  useEffect(() => {
    setData(RakingData[researchArea])
  }, [researchArea])

  const handleClick = (indicador: string) => {
    router.push('/indicadores')
    handleCommitedIndicator(indicador)
  }

  if (indicatorsData?.length > 0) {
    return (
      <Container background={data?.config?.color}>
        <Image className='icon' src={data?.config?.img} width={50} height={50} />
        <h3>{data?.config?.label_complete}</h3>
        <p className='subtitle' >Visão por indicador</p>
        <LayerDiv>
          {indicatorsData?.map((indicador: IVariacoes, index: number) => {
            return (
              <span onClick={() => handleClick(indicador.code)}>
                 <Card key={Math.random()} background={data?.config?.color} data={indicador} i={index} />
              </span>
            )
          })}
        </LayerDiv>
      </Container>
    );
  }
  return <></>
}
